import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { GET_RFQS_CONTRACT_DETAILS, GET_CURRENCY_DETAILS } from 'Constants/actionConstants';
import { PROVIDER_VALUE } from 'Constants/commonConstants';
import { getCompanyType } from 'Utils/storage';
import { getItemFromLocal } from 'Utils/localStorage';
import Moment from 'moment';
import ReactToPrint from 'react-to-print';
import Sticky from 'Components/Sticky';
import { ReactComponent as BackIcon } from 'Icons/back.svg';
import TEGLogo from 'Icons/T_EG.jpg';

// ─── styles ───────────────────────────────────────────────────────────────────
const th = {
    border: '1px solid #555',
    padding: '4px 7px',
    backgroundColor: '#1a3c6e',
    color: '#fff',
    fontSize: '11px',
    textAlign: 'left',
};
const td = {
    border: '1px solid #555',
    padding: '4px 7px',
    fontSize: '11px',
    color: '#000',
};
const sectionHeader = {
    backgroundColor: '#1a3c6e',
    color: '#fff',
    padding: '4px 7px',
    fontWeight: 'bold',
    fontSize: '11px',
    marginBottom: '2px',
};
const tbl = {
    width: '100%',
    borderCollapse: 'collapse',
    marginBottom: '6px',
};

// ─── printable content ────────────────────────────────────────────────────────
class LOIPrintContent extends Component {

    getContractPeriod() {
        const { liner } = this.props;
        const label = liner.is_contract_tenure_updated ? 'Extended Contract Period' : 'CONTRACT PERIOD';

        if (liner.trip_contract_tenure_from && liner.trip_contract_tenure_to) {
            return {
                from: Moment(liner.trip_contract_tenure_from).format('DD/MM/YYYY'),
                to: Moment(liner.trip_contract_tenure_to).format('DD/MM/YYYY'),
                label
            };
        } else {
            return {
                from: Moment(liner.contract_tenure_from).format('DD/MM/YYYY'),
                to: Moment(liner.contract_tenure_to).format('DD/MM/YYYY'),
                label
            };
        }
    }

    getNumberOfContainers() {
        const { liner } = this.props;
        return {
            value: liner.no_of_containers,
            label: liner.is_no_of_containers_updated ? 'Changed Number of Containers' : 'No. of Containers'
        };
    }

    render() {
        const { liner, rfqDetails, currencyDetails } = this.props;
        const usdCurrencyObj = (currencyDetails || []).find(c => c.currency_type === 1) || {};
        if (!liner) return null;

        const movement = `${liner.from} - ${liner.to}`;
        const companyName = rfqDetails.company_name || '';
        const rfqNumber = rfqDetails.rfq_number || '';
        const branchName = rfqDetails.branch_name || '';
        const serviceTypeName = rfqDetails.service_type_name || '';
        const movementTypeName = rfqDetails.movement_type_name || '';
        const pricingBasisName = rfqDetails.pricing_basis_name || '';
        const paymentCycleName = rfqDetails.payment_cycle_name || '';
        const productCategoryName = rfqDetails.product_category_name || '';
        const contractNote = rfqDetails.contract_note || '';
        const floatedBy = rfqDetails.floated_by || '';

        const contractFrom = rfqDetails.contract_tenure_from ? Moment(rfqDetails.contract_tenure_from).format('DD/MM/YYYY') : '';
        const contractTo = rfqDetails.contract_tenure_to ? Moment(rfqDetails.contract_tenure_to).format('DD/MM/YYYY') : '';
        const loiIssuedDate = liner.loi_issued_date ? Moment(liner.loi_issued_date).format('DD/MM/YYYY HH:mm:ss') : '';
        const loiAcceptedDate = liner.loi_accepted_date ? Moment(liner.loi_accepted_date).format('DD/MM/YYYY HH:mm:ss') : '';
        const tatStr = liner.tat ? `${liner.tat.value} ${liner.tat.name}` : '';

        return (
            <div style={{ width: '210mm', minHeight: '297mm', padding: '8mm', fontFamily: 'Arial, sans-serif', color: '#000', backgroundColor: '#fff', boxSizing: 'border-box', pageBreakAfter: 'always', overflow: 'hidden' }}>

                {/* transporteg pre-header */}
                <div style={{ marginBottom: '6px' }}>
                    <img src={TEGLogo} alt="TransportEG" style={{ height: '38px', marginBottom: '2px' }} />
                </div>
                <hr style={{ borderColor: '#999', marginBottom: '6px', marginTop: '2px' }} />

                {/* header */}
                <div style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '13px', marginBottom: '3px' }}>
                    {companyName}
                </div>
                <div style={{ textAlign: 'center', fontSize: '11px', marginBottom: '6px' }}>
                    TEG || LOI Acceptance ({movement}) RFQ No: {rfqNumber}
                </div>
                <hr style={{ borderColor: '#999', marginBottom: '6px' }} />

                {/* ref / loi row */}
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '3px', fontSize: '11px' }}>
                    <span><strong>REF RFQ : {rfqNumber}</strong></span>
                    <span>Date : {rfqDetails.created ? Moment(rfqDetails.created).format('DD/MM/YYYY') : ''}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px', fontSize: '11px' }}>
                    <span>LOI No.: {''}</span>
                    <span>Date : {rfqDetails.created ? Moment().format('DD/MM/YYYY') : ''}</span>
                </div>

                <div style={{ fontWeight: 'bold', fontSize: '12px', color: '#1a3c6e', marginBottom: '6px' }}>
                    Company Name : {companyName}
                </div>
                <hr style={{ borderColor: '#999', marginBottom: '6px' }} />

                {/* contract details table */}
                <table style={tbl}>
                    <tbody>
                        <tr>
                            <td style={td}><strong>To :</strong></td>
                            <td style={td} colSpan={3}>{liner.transporter_name || ''}</td>
                        </tr>
                        <tr>
                            <td style={td}><strong>Pan Number :</strong></td>
                            <td style={td} colSpan={3}>{liner.pan_number || ''}</td>
                        </tr>
                        <tr>
                            <td style={td}><strong>Desk Name :</strong></td>
                            <td style={td} colSpan={3}>{rfqDetails.desk_name}</td>
                        </tr>
                        <tr>
                            <td style={td}><strong>CONTRACT PERIOD :</strong></td>
                            <td style={td}>From : {contractFrom}</td>
                            <td style={td}>To : {contractTo}</td>
                            <td style={td}></td>
                        </tr>
                        <tr>
                            <td style={td}><strong>SERVICE TYPE :</strong></td>
                            <td style={td} colSpan={3}>{serviceTypeName}</td>
                        </tr>
                        <tr>
                            <td style={td}><strong>CONTRACT NOTE :</strong></td>
                            <td style={td} colSpan={3}>{contractNote || ''}</td>
                        </tr>
                        <tr>
                            <td style={td}><strong>Container free day :</strong></td>
                            <td style={td}>{liner.container_free_day || ''}</td>
                            <td style={td}><strong>No. of Containers :</strong></td>
                            <td style={td}>{liner.no_of_containers}</td>
                        </tr>
                        <tr>
                            <td style={td}><strong>Container Type :</strong></td>
                            <td style={td}>{liner.vehicle_type_name || ''}</td>
                            <td style={td}><strong>Container Body Type :</strong></td>
                            <td style={td}>{liner.vehicle_body_type_name || ''}</td>
                        </tr>
                        <tr>
                            <td style={td}><strong>Total cost in USD :</strong></td>
                            <td style={td}>{liner.price / usdCurrencyObj.usdtoinr}</td>
                            <td style={td}><strong>Total cost in INR :</strong></td>
                            <td style={td}>{liner.price || ''}</td>
                        </tr>
                        <tr>
                            <td style={td}><strong>Shipping line</strong></td>
                            <td style={td} colSpan={3}>{liner.shipping_line_name || ''}</td>
                        </tr>
                        <tr>
                            <td style={td}><strong>USD to INR conversion Value:</strong></td>
                            <td style={td} colSpan={3}>{usdCurrencyObj.usdtoinr}</td>
                        </tr>
                    </tbody>
                </table>

                {/* movement / bid section */}
                <div style={sectionHeader}>
                    FOR {movement} MODE,{movementTypeName} Movement
                </div>
                <table style={tbl}>
                    <thead>
                        <tr>
                            <th style={th}>Movement</th>
                            <th style={th}>Operation</th>
                            <th style={th}>Transit Days</th>
                            <th style={th}>Challenge Price</th>
                            <th style={th}>Price</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style={td}>{movement}</td>
                            <td style={td}>{liner.vehicle_type_name || ''}</td>
                            <td style={td}>{(liner.tat.value + " " + liner.tat.name) || ''}</td>
                            <td style={td}>{liner.challenge_price || 0}</td>
                            <td style={td}>{(liner.price + " " + liner.pricing_basis) || ''}</td>
                        </tr>
                    </tbody>
                </table>

                {/* Cost Heads */}
                {(liner.multi_mode_heading_charges || []).length > 0 && <>
                    <div style={sectionHeader}>All Cost Heads</div>
                    <table style={tbl}>
                        <thead>
                            <tr>
                                <th style={th}>Cost Head</th>
                                <th style={th}>UOM</th>
                                <th style={th}>Cost in INR</th>
                                <th style={th}>Cost in USD</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(liner.multi_mode_heading_charges || []).map((charge, i) => (
                                <tr key={i}>
                                    <td style={td}>{charge.headingChargesValue}</td>
                                    <td style={td}>{charge.headingChargesBusinessVolumeUnitName}</td>
                                    <td style={td}>{charge.headingChargesCp_inr}</td>
                                    <td style={td}>{charge.headingChargesCp_usd}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </>}

                {/* Payment Cycle Days & t&c */}
                <table style={tbl}>
                    <tbody>
                        <tr>
                            <td style={td}><strong>Payment Cycle Days:</strong></td>
                            <td style={td}>{paymentCycleName}</td>
                        </tr>
                        <tr>
                            <td style={td}><strong>TERMS &amp; CONDITIONS :</strong></td>
                            <td style={td}>As per attachment. Also please Refer to RFQ Notes</td>
                        </tr>
                         <tr>
                            <td style={td}><strong>Vendor Remarks:</strong></td>
                            <td style={{...td, fontSize: '11px',  }} colSpan={3}>{liner.provider_bid_remarks || ''}</td>
                        </tr>
                         <tr>
                            <td style={td}><strong>LOI Remarks:</strong></td>
                            <td style={{...td, fontSize: '11px', }} colSpan={3}>{liner.sent_loi_for_approver_remarks || ''}</td>
                        </tr>
                    </tbody>
                </table>

                {/* footer */}
                <div style={{ backgroundColor: '#1a3c6e', color: '#fff', padding: '4px 7px', fontWeight: 'bold', fontSize: '11px', marginTop: '6px' }}>
                    Please contact your respective deskhead.
                </div>
                <div style={{ fontSize: '11px', marginTop: '3px' }}>Head: <strong>{(rfqDetails.desk_head && rfqDetails.desk_head.name) || ''}</strong></div>
                <div style={{ fontSize: '11px' }}>Email: <strong>{(rfqDetails.desk_head && rfqDetails.desk_head.email) || ''}</strong></div>
                <div style={{ fontSize: '11px', marginBottom: '3px' }}>Contact: <strong>{(rfqDetails.desk_head && rfqDetails.desk_head.contact) || ''}</strong></div>

                <div style={{ fontSize: '11px', marginTop: '5px', marginBottom: '2px' }}><strong>Instructions</strong>:</div>
                <div style={{ fontSize: '11px' }}>kindly download the terms &amp; conditions.</div>
                {(rfqDetails.docs || []).length > 0 && (
                    <div style={{ fontSize: '11px', color: '#528aea', textDecoration: 'underline', marginTop: '2px' }}>
                        <a href={(rfqDetails.docs[0] || {}).url} download style={{ color: '#528aea' }}>
                            {(rfqDetails.docs[0] || {}).name}
                        </a>
                    </div>
                )}

                <hr style={{ borderColor: '#555', marginTop: '8px', marginBottom: '5px' }} />

                <div style={{ fontSize: '11px' }}>Best Regards From</div>
                <div style={{ fontSize: '11px', marginBottom: '5px' }}>Call Back No : {'8767227722'}</div>

                <div style={{ textAlign: 'center', marginTop: '5px', fontSize: '11px', fontWeight: 'bold' }}>Sclen.ai</div>
                <div style={{ textAlign: 'center', fontSize: '11px' }}>{'8767227722'}</div>
                <div style={{ textAlign: 'center', fontSize: '11px', marginBottom: '3px' }}>commandcentre@caliperbusiness.com</div>
                <div style={{ textAlign: 'center', fontSize: '11px', color: '#528aea' }}>
                    <a href="https://ilms.awlagri.in" style={{ color: '#528aea' }}>https://ilms.awlagri.in</a> | Sclen.ai 2015, All Rights Reserved
                </div>
            </div>
        );
    }
}

// ─── main page ────────────────────────────────────────────────────────────────
class LOIDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            liners: [],
            rfqDetails: {},
        };
    }

    componentDidMount() {
        const { dispatch, match } = this.props;
        const rfqId = match.params.id;
        const transporterId = match.params.transporterId;
        const rfqType = match.params.type;
        const statusType = match.params.statusType;
        const seekerCompanyId = match.params.seekerCompanyId;

        dispatch({
            type: GET_RFQS_CONTRACT_DETAILS,
            params: {
                rfqId,
                rfqType: rfqType && Number(rfqType),
                transporterId,
                type: statusType && Number(statusType),
                limit: 6000,
                offset: 0,
                seekerCompanyId: seekerCompanyId && Number(seekerCompanyId),
            },
            isTransporter: getCompanyType() === PROVIDER_VALUE,
            onSuccess: (data) => {
                console.log('data:', data)
                const rfqLines = data.list.bids[0] || [];
                console.log('rfqLines:', rfqLines)
                const rfq = data.rfq || {};
                this.setState({
                    liners: rfqLines || [],
                    rfqDetails: rfq,
                });
                dispatch({
                    type: GET_CURRENCY_DETAILS,
                    data: {
                        companyId: rfq.company_id,
                        branchId: rfq.branch_id,
                        seekerCompanyId: getItemFromLocal('transporter_seeker_company_id'),
                    }
                });
            }
        });
    }

    render() {
        const { liners, rfqDetails } = this.state;
        const { currencyDetails } = this.props;
        return (
            <Sticky>
                <div className="pl-20 pr-20 pt-20 pb-20">
                    <div>
                        <Link className="ht-30 flex flex-middle pl-40 wt-max-content mb-10 mt-5" to="/contractRecords">
                            <BackIcon className="mr-10 fill-theme curP" />
                        </Link>
                    </div>
                    <div className="mb-10 tCenter header-medium-color fSemibold fs-20 mt-10">
                        LOI Details
                    </div>

                    <div style={{ backgroundColor: '#e0e0e0', padding: '30px 0', display: 'flex', flexDirection: 'column' }}>
                        <div className="flex mb-20">
                            <ReactToPrint
                                trigger={() => (
                                    <button className="br-20 theme-color border-theme fs-16 fBold pl-30 pr-30 mr-10 print-trips-button curP ht-40 ml-10">
                                        Print
                                    </button>
                                )}
                                content={() => this.printRef}
                            />
                        </div>
                        <div ref={el => (this.printRef = el)} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
                            {liners.length > 0 ? liners.map((liner, i) => (
                                <div key={i} style={{ boxShadow: '0 2px 12px rgba(0,0,0,0.25)', marginBottom: '30px' }}>
                                    <LOIPrintContent liners={liners} liner={liner} rfqDetails={rfqDetails} currencyDetails={currencyDetails} />
                                </div>
                            )) : (
                                <LOIPrintContent liner={null} />
                            )}
                        </div>
                    </div>
                </div>
            </Sticky>
        );
    }
}

const mapStateToProps = ({ constants }) => ({
    currencyDetails: constants.currencyDetails || [],
});

export default connect(mapStateToProps)(LOIDetails);
